<template lang="pug">
  student-actions(
    escort-mode
    :module-id="moduleItem.id"
  )
</template>

<script>
import StudentActions from '@/modules/Education/Teach/components/StudentActions.vue';

export default {
  components: {
    StudentActions,
  },
  props: {
    // Instance Module.js
    moduleItem: { type: Object, required: true },
  },
};
</script>
